import * as actions from './actionsTypes';

const initialData = {
  loading: false,
  saveLoader: false,
  categoryLength: 0,
  category: [],
}

export default function categoryReducer(state = initialData, action){
  switch (action.type) {
    case actions.LOADING_CATEGORY:
      return {...state, loading: action.payload}
    case actions.SAVE_LOADER_CATEGORY:
      return {...state, saveLoader: action.payload}
    case actions.GET_CATEGORY:
      return {...state, category: action.payload.category, categoryLength: action.payload.categoryLength}
    default:
      return {...state};
  }
}